// Add this debounce function at the beginning of your file
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

const elements = {
  menuButton: document.getElementById('menu-button'),
  closeButton: document.getElementById('close-menu'),
  cartButton: document.getElementById('cart-button'),
  closeCartButton: document.getElementById('close-cart-menu'),
  menu: document.getElementById('menu'),
  cartMenu: document.getElementById('cart-menu'),
  overlay: document.getElementById('overlay'),
  addToCartForm: document.getElementById('add-to-cart-form'),
  sizeSelect: document.getElementById('size-select'),
  addToCartButton: document.getElementById('add-to-cart-btn'),
  colorOptions: document.querySelector('.color-options'),
};

let productSplide;
let lastValidImageIndex = 0;

// Reusable functions
const toggleMenu = (menuElement, open) => {
  const translateClass = menuElement === elements.menu ? '-translate-x-full' : 'translate-x-full';
  menuElement.classList.toggle(translateClass, !open);
  elements.overlay.classList.toggle('opacity-0', !open);
  elements.overlay.classList.toggle('pointer-events-none', !open);
  document.body.style.overflow = open ? 'hidden' : '';
};

const fetchCartData = () => fetch('/cart.js').then(response => response.json());

const updateCart = (cart) => {
  updateMenuCart(cart);
  updateMainCart(cart);
  updateCartCount(cart.item_count);
};

const updateCartContents = () => {
  fetchCartData()
    .then(updateCart)
    .catch(error => console.error('Error updating cart contents:', error));
};

const debouncedUpdateCartContents = debounce(updateCartContents, 300);

const updateCartItemElement = (cartItem, item, prefix) => {
  const cartItemElement = cartItem.querySelector('.cart-item');
  cartItemElement.dataset.key = item.key;
  cartItemElement.dataset.unitPrice = item.price;
  
  const img = cartItem.querySelector('img');
  img.src = item.image;
  img.alt = item.title;
  
  const titleLink = cartItem.querySelector('.cart-item-title-link');
  titleLink.href = item.url;
  titleLink.textContent = item.product_title;
  
  const variantTitle = cartItem.querySelector('.cart-item-variant');
  if (item.variant_title && item.variant_title !== 'Default Title') {
    variantTitle.textContent = item.variant_title;
  } else {
    variantTitle.remove();
  }
  
  const quantityInput = cartItem.querySelector('.cart-item-quantity-input');
  quantityInput.value = item.quantity;
  quantityInput.dataset.key = item.key;
  quantityInput.id = `${prefix}quantity-${item.key}`;
  
  const price = cartItem.querySelector('.cart-item-price');
  price.textContent = Shopify.formatMoney(item.line_price);
};

const handleCartQuantityChange = (event) => {
  const target = event.target;
  const button = target.closest('.cart-item-quantity-decrease, .cart-item-quantity-increase');
  
  if (button) {
    event.preventDefault();
    const wrapper = button.closest('.cart-item-quantity-wrapper');
    const input = wrapper.querySelector('.cart-item-quantity-input');
    const key = input.dataset.key;
    let quantity = parseInt(input.value);

    if (button.classList.contains('cart-item-quantity-decrease')) {
      quantity = quantity > 1 ? quantity - 1 : 0;
    } else if (button.classList.contains('cart-item-quantity-increase')) {
      quantity += 1;
    }

    input.value = quantity;
    
    // Update price immediately in both main cart and menu cart
    updateItemPrice(key, quantity);
    
    // Update cart on server and refresh totals
    updateCartItemQuantity(key, quantity);
  }
};

const updateItemPrice = (key, quantity) => {
  const cartItems = document.querySelectorAll(`.cart-item[data-key="${key}"]`);
  
  cartItems.forEach(cartItem => {
    const priceElement = cartItem.querySelector('.cart-item-price');
    const unitPrice = parseFloat(cartItem.dataset.unitPrice);
    if (priceElement && !isNaN(unitPrice)) {
      const newPrice = unitPrice * quantity;
      priceElement.textContent = Shopify.formatMoney(newPrice);
    }
    
    const quantityInput = cartItem.querySelector('.cart-item-quantity-input');
    if (quantityInput) {
      quantityInput.value = quantity;
    }
  });

  updateTotalPriceEstimate();
};

const updateTotalPriceEstimate = () => {
  const cartItems = document.querySelectorAll('#cart-items-container .cart-item');
  let totalPrice = 0;

  cartItems.forEach(item => {
    const price = parseFloat(item.dataset.unitPrice);
    const quantity = parseInt(item.querySelector('.cart-item-quantity-input').value);
    totalPrice += price * quantity;
  });

  const cartTotal = document.getElementById('cart-total');
  if (cartTotal) {
    cartTotal.textContent = Shopify.formatMoney(totalPrice);
  }
};

const updateCartItemQuantity = (key, quantity) => {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id: key, quantity: quantity })
  })
  .then(response => response.json())
  .then(cart => {
    if (quantity === 0) {
      // Remove the item from both main cart and menu cart
      const mainCartItem = document.querySelector(`#cart-items-container .cart-item[data-key="${key}"]`);
      const menuCartItem = document.querySelector(`#menu-cart-items-container .cart-item[data-key="${key}"]`);
      
      if (mainCartItem) mainCartItem.remove();
      if (menuCartItem) menuCartItem.remove();
    }

    // Update cart contents (this will update totals and any discrepancies)
    updateCartContents();

    // Check if cart is empty and update UI accordingly
    if (cart.item_count === 0) {
      updateEmptyCartState();
    }
  })
  .catch(error => console.error('Error updating cart:', error));
};

const updateEmptyCartState = () => {
  const mainCartContainer = document.getElementById('cart-items-container');
  const menuCartContainer = document.getElementById('menu-cart-items-container');

  if (mainCartContainer) {
    mainCartContainer.innerHTML = `
      <div class="my-4">Warenkorb ist leer</div>
      <a class="button w-full text-center" href="/">Weitershoppen</a>
    `;
  }

  if (menuCartContainer) {
    menuCartContainer.innerHTML = `
      <div class="p-2">
        <p>Dein Warenkorb ist leer.</p>
      </div>
    `;
  }

  // Hide checkout buttons and totals
  const checkoutButton = document.querySelector('button[name="checkout"]');
  const additionalCheckoutButtons = document.querySelector('.additional-checkout-buttons');
  const cartTotalContainer = document.querySelector('.cart-total-container');
  const cartNoteSection = document.querySelector('.cart-note-section');

  if (checkoutButton) checkoutButton.style.display = 'none';
  if (additionalCheckoutButtons) additionalCheckoutButtons.style.display = 'none';
  if (cartTotalContainer) cartTotalContainer.style.display = 'none';
  if (cartNoteSection) cartNoteSection.style.display = 'none';
};

const selectColor = (button) => {
  // Remove 'selected' class from all color buttons
  document.querySelectorAll('.color-option').forEach(btn => btn.classList.remove('selected'));
  
  // Add 'selected' class to clicked button
  button.classList.add('selected');
  
  // Get selected color
  const selectedColor = button.getAttribute('data-color');
  
  // Update available sizes based on selected color
  updateAvailableSizes(selectedColor);

  // Check if any sizes are available
  const sizeSelect = document.getElementById('size-select');
  const availableSizes = Array.from(sizeSelect.options).filter(option => !option.disabled && option.value !== "");
  
  const addToCartButton = document.getElementById('add-to-cart-btn');
  if (availableSizes.length === 0) {
    // No sizes available, disable add to cart button
    addToCartButton.textContent = 'Ausverkauft';
    addToCartButton.disabled = true;
  } else {
    // Reset add to cart button
    resetAddToCartButton(addToCartButton);
  }

  // Find the first available variant with this color and update the image
  const variants = JSON.parse(document.getElementById('product-variants').textContent);
  const selectedVariant = variants.find(variant => variant.options.includes(selectedColor) && variant.available);
  if (selectedVariant) {
    updateProductImage(selectedVariant);
    // Update URL with selected color
    updateURL(selectedColor);
  }

  // Update the size select with the selected color
  if (sizeSelect) {
    sizeSelect.dispatchEvent(new Event('change'));
  }
};

const addToCart = (event) => {
  event.preventDefault();
  
  const form = document.getElementById('add-to-cart-form');
  const colorOptions = document.querySelector('.color-options');
  const sizeSelect = document.getElementById('size-select');
  const addToCartButton = document.getElementById('add-to-cart-btn');
  const productionModelCheckbox = document.getElementById('production-model');
  
  // Check if color selection is required and made
  if (colorOptions) {
    const selectedColor = document.querySelector('.color-option.selected');
    if (!selectedColor) {
      setAddToCartButtonError(addToCartButton);
      return;
    }
  }

  // Check if size selection is required and made
  if (sizeSelect && sizeSelect.value === "") {
    setAddToCartButtonError(addToCartButton);
    return;
  }

  // Check if production model checkbox exists and is required
  if (productionModelCheckbox && addToCartButton.dataset.requiresCheckbox === 'true' && !productionModelCheckbox.checked) {
    addToCartButton.style.backgroundColor = '#FF0000';
    addToCartButton.style.color = '#FFFFFF';
    addToCartButton.innerHTML = 'Bitte bestätigen';
    return;
  }

  // Reset button appearance if all validations pass
  resetAddToCartButton(addToCartButton);

  // Get selected color and size
  const selectedColor = document.querySelector('.color-option.selected')?.getAttribute('data-color');
  const selectedSize = sizeSelect ? sizeSelect.value : null;

  // Find the correct variant ID based on selected options
  const variantsElement = document.getElementById('product-variants');
  let variants = [];
  
  if (variantsElement) {
    try {
      variants = JSON.parse(variantsElement.textContent);
    } catch (error) {
      console.error('Error parsing product variants:', error);
    }
  }

  let selectedVariant;

  if (variants.length > 0) {
    if (colorOptions && selectedSize) {
      selectedVariant = variants.find(variant => 
        variant.options.includes(selectedColor) && variant.options.includes(selectedSize)
      );
    } else if (colorOptions) {
      selectedVariant = variants.find(variant => 
        variant.options.includes(selectedColor)
      );
    } else if (selectedSize) {
      selectedVariant = variants.find(variant => 
        variant.options.includes(selectedSize)
      );
    } else {
      selectedVariant = variants[0];
    }
  } else {
    selectedVariant = { id: form.querySelector('input[name="id"]').value };
  }

  if (!selectedVariant) {
    alert('Die gewählte Kombination ist nicht verfügbar');
    return;
  }

  // Update the form data with the correct variant ID
  const formData = new FormData(form);
  formData.set('id', selectedVariant.id);

  // Set loading state
  addToCartButton.textContent = 'Hinzufügen...';
  addToCartButton.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(data => {
    console.log('Product added to cart:', data);

    // Show the hidden notification with animation
    const notification = document.querySelector('.notification');
    if (notification) {
      notification.classList.add('show');
    }

    // Update the cart contents dynamically
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        updateMenuCart(cart);
        updateMainCart(cart);
        updateCartCount(cart.item_count); // This line updates the cart count

        // Show the menu cart footer immediately
        const menuCartFooter = document.querySelector('.menu-cart-footer');
        if (menuCartFooter) {
          menuCartFooter.style.display = 'block';
        }
      })
      .catch(error => console.error('Error updating cart contents:', error));
  })
  .catch(error => {
    console.error('Error:', error);
  })
  .finally(() => {
    // Reset button state
    resetAddToCartButton(addToCartButton);
  });
};

// Event listeners setup
const setupEventListeners = () => {
  elements.menuButton.addEventListener('click', () => toggleMenu(elements.menu, true));
  elements.closeButton.addEventListener('click', () => toggleMenu(elements.menu, false));
  elements.cartButton.addEventListener('click', () => toggleMenu(elements.cartMenu, true));
  elements.closeCartButton.addEventListener('click', () => toggleMenu(elements.cartMenu, false));
  elements.overlay.addEventListener('click', () => {
    toggleMenu(elements.menu, false);
    toggleMenu(elements.cartMenu, false);
  });

  document.addEventListener('click', handleCartQuantityChange);

  if (elements.addToCartForm) {
    elements.addToCartForm.addEventListener('submit', addToCart);
  }

  if (elements.sizeSelect) {
    elements.sizeSelect.addEventListener('change', () => {
      resetAddToCartButton(elements.addToCartButton);
      updateProductImageBasedOnSelection();
    });
  }

  if (elements.colorOptions) {
    elements.colorOptions.addEventListener('click', (event) => {
      if (event.target.classList.contains('color-option')) {
        selectColor(event.target);
      }
    });
  }
};

// Initialization
document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM loaded, initializing cart');
  setupEventListeners();
  selectColorFromURL();
  
  const cartItemsContainer = document.getElementById('cart-items-container');
  if (cartItemsContainer && !cartItemsContainer.querySelector('#cart-items')) {
    updateCartContents();
  }

  const productionModelCheckbox = document.getElementById('production-model');
  const addToCartButton = document.getElementById('add-to-cart-btn');
  
  if (productionModelCheckbox && addToCartButton) {
    productionModelCheckbox.addEventListener('change', function() {
      if (this.checked) {
        resetAddToCartButton(addToCartButton);
      }
    });
  }
});

function updateMenuCart(cart) {
  console.log('Updating menu cart');
  const menuCartItemsContainer = document.getElementById('menu-cart-items-container');
  const menuCartItemTemplate = document.getElementById('menu-cart-item-template');
  const menuCartFooter = document.querySelector('.menu-cart-footer');
  
  if (!menuCartItemsContainer) {
    console.error('Menu cart items container not found');
    return;
  }

  // Clear existing items
  menuCartItemsContainer.innerHTML = '';
  
  if (cart.items.length === 0) {
    // Cart is empty, show the empty cart message
    menuCartItemsContainer.innerHTML = `
      <div class="p-2">
        <p>Dein Warenkorb ist leer.</p>
      </div>
    `;
    // Hide the menu cart footer
    if (menuCartFooter) {
      menuCartFooter.style.display = 'none';
    }
  } else {
    // Cart has items, proceed with normal update
    const ul = document.createElement('ul');
    ul.id = 'menu-cart-items';
    ul.className = 'cart-items-list';
    
    cart.items.forEach(item => {
      const cartItem = menuCartItemTemplate.content.cloneNode(true);
      updateCartItemElement(cartItem, item, 'menu-');
      ul.appendChild(cartItem);
    });
    
    menuCartItemsContainer.appendChild(ul);
    
    // Add or update total
    let totalContainer = menuCartItemsContainer.querySelector('.cart-total-container');
    if (!totalContainer) {
      totalContainer = document.createElement('div');
      totalContainer.className = 'cart-total-container';
      totalContainer.innerHTML = `
        <div class="cart-total-price">Zwischensumme <span id="menu-cart-total"></span></div>
        <div class="cart-total-note">
          Versandkosten werden im nächsten Schritt berechnet
        </div>
      `;
      menuCartItemsContainer.appendChild(totalContainer);
    }
    
    const menuCartTotal = totalContainer.querySelector('#menu-cart-total');
    if (menuCartTotal) {
      menuCartTotal.textContent = Shopify.formatMoney(cart.total_price);
    }

    // Show the menu cart footer
    if (menuCartFooter) {
      menuCartFooter.style.display = 'block';
    }
  }
}

function updateMainCart(cart) {
  const cartItemsContainer = document.getElementById('cart-items-container');
  const cartItemTemplate = document.getElementById('cart-item-template');
  const cartTotal = document.getElementById('cart-total');
  const cartForm = document.querySelector('form[action="/cart"]');
  
  if (cartItemsContainer) {
    // Check if the cart is already populated
    if (cartItemsContainer.querySelector('#cart-items') && cart.items.length > 0) {
      // Cart is already populated, just update quantities and totals
      updateExistingCartItems(cart);
      return;
    }

    cartItemsContainer.innerHTML = '';
    
    if (cart.items.length === 0) {
      // Cart is empty
      cartItemsContainer.innerHTML = `
        <div class="my-4">Warenkorb ist leer</div>
        <a class="button w-full text-center" href="/">Weitershoppen</a>
      `;
      
      // Hide the cart total, checkout button, and other elements
      if (cartTotal) cartTotal.closest('.cart-total-container').style.display = 'none';
      const checkoutButton = cartForm.querySelector('button[name="checkout"]');
      if (checkoutButton) checkoutButton.style.display = 'none';
      
      // Hide additional checkout buttons if they exist
      const additionalCheckoutButtons = cartForm.querySelector('.additional-checkout-buttons');
      if (additionalCheckoutButtons) additionalCheckoutButtons.style.display = 'none';
    } else {
      // Cart has items
      const ul = document.createElement('ul');
      ul.id = 'cart-items';
      ul.className = 'cart-items-list';
      
      cart.items.forEach(item => {
        const cartItem = cartItemTemplate.content.cloneNode(true);
        updateCartItemElement(cartItem, item, 'cart-');
        ul.appendChild(cartItem);
      });
      
      cartItemsContainer.appendChild(ul);
      
      // Show and update the cart total
      if (cartTotal) {
        cartTotal.textContent = Shopify.formatMoney(cart.total_price);
        cartTotal.closest('.cart-total-container').style.display = '';
      }
      
      // Show the checkout button
      const checkoutButton = cartForm.querySelector('button[name="checkout"]');
      if (checkoutButton) checkoutButton.style.display = '';
      
      // Show additional checkout buttons if they exist
      const additionalCheckoutButtons = cartForm.querySelector('.additional-checkout-buttons');
      if (additionalCheckoutButtons) additionalCheckoutButtons.style.display = '';
    }
  }
}

function updateExistingCartItems(cart) {
  cart.items.forEach(item => {
    const cartItem = document.querySelector(`.cart-item[data-key="${item.key}"]`);
    if (cartItem) {
      const quantityInput = cartItem.querySelector('.cart-item-quantity-input');
      if (quantityInput) {
        quantityInput.value = item.quantity;
      }
      updateItemPrices(item.key, item.quantity);
    }
  });

  // Update total
  const cartTotal = document.getElementById('cart-total');
  if (cartTotal) {
    cartTotal.textContent = Shopify.formatMoney(cart.total_price);
  }
}

function updateItemPriceAndTotal(item, newQuantity) {
  const newLinePrice = item.price * newQuantity;
  const cartItem = document.querySelector(`.cart-item[data-key="${item.key}"]`);
  const priceElement = cartItem.querySelector('.cart-item-price');
  priceElement.textContent = Shopify.formatMoney(newLinePrice);

  // Update the total price
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartTotal = document.getElementById('cart-total');
      if (cartTotal) {
        cartTotal.textContent = Shopify.formatMoney(cart.total_price);
      }
    })
    .catch(error => console.error('Error updating total price:', error));
}

function updateCartCount(count) {
  const cartCountElement = document.querySelector('#cart-button .cart-count');
  const cartNotificationCount = document.getElementById('cart-notification-count');
  
  if (cartCountElement) {
    cartCountElement.textContent = count;
    if (count > 0) {
      cartCountElement.classList.remove('hidden');
    } else {
      cartCountElement.classList.add('hidden');
    }
  }
  
  if (cartNotificationCount) {
    cartNotificationCount.textContent = count;
  }
}

// Updated function to update URL
function updateURL(color) {
  if (history.pushState) {
    const formattedColor = color.toLowerCase().replace(/\s+/g, '-');
    const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?color=' + encodeURIComponent(formattedColor);
    window.history.pushState({path:newurl},'',newurl);
  }
}

// Updated function to select color from URL parameter
function selectColorFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  const color = urlParams.get('color');
  if (color) {
    const formattedColor = color.replace(/-/g, ' ');
    const colorButton = document.querySelector(`.color-option[data-color="${formattedColor}"]`);
    if (colorButton) {
      selectColor(colorButton);
    }
  }
}

function updateAvailableSizes(color) {
  const sizeSelect = document.getElementById('size-select');
  const variants = JSON.parse(document.getElementById('product-variants').textContent);
  
  // Store the current selection
  const currentSelection = sizeSelect.value;

  // Get the original option name
  const originalOptionName = sizeSelect.querySelector('option[value=""]').textContent;
  
  // Clear current options
  sizeSelect.innerHTML = `<option selected disabled value="">${originalOptionName}</option>`;

  // Add size options for the selected color
  const availableSizes = new Set();
  const unavailableSizes = new Set();
  variants.forEach(variant => {
    if (variant.option1 === color || variant.option2 === color) {
      const size = variant.options.find(opt => opt !== color);
      if (variant.available) {
        availableSizes.add(size);
      } else {
        unavailableSizes.add(size);
      }
    }
  });

  // Add available sizes
  availableSizes.forEach(size => {
    const option = document.createElement('option');
    option.value = size;
    option.textContent = size;
    sizeSelect.appendChild(option);
  });

  // Add unavailable sizes (disabled)
  unavailableSizes.forEach(size => {
    if (!availableSizes.has(size)) {
      const option = document.createElement('option');
      option.value = size;
      option.textContent = size + ' - Ausverkauft';
      option.disabled = true;
      sizeSelect.appendChild(option);
    }
  });

  // Restore the previous selection if it's still available
  if (Array.from(sizeSelect.options).some(option => option.value === currentSelection && !option.disabled)) {
    sizeSelect.value = currentSelection;
  } else {
    sizeSelect.value = ""; // Reset to default option if previous selection is not available
  }

  // Find the first available variant with this color and update the image
  const selectedVariant = variants.find(variant => variant.options.includes(color) && variant.available);
  if (selectedVariant) {
    updateProductImage(selectedVariant);
  }
}

// New function to set error state on Add to Cart button
function setAddToCartButtonError(button) {
  button.textContent = 'Bitte wählen';
  button.style.backgroundColor = 'red';
  button.style.color = 'white';
  button.disabled = true;
}

// New function to reset Add to Cart button
function resetAddToCartButton(button) {
  button.textContent = 'In den Warenkorb';
  button.style.backgroundColor = '';
  button.style.color = '';
  button.disabled = false;
}

function closeNotification() {
  const notification = document.querySelector('.notification');
  if (notification) {
    notification.classList.remove('show');
  }
}

Shopify.formatMoney = function(cents, format = "€{{amount}}") {
  var value = (cents / 100).toFixed(2).replace('.', ',');
  return format.replace("{{amount}}", value);
};

function findVariantImageIndex(variant) {
  const variantImage = variant.featured_image;
  if (!variantImage) {
    return -1;
  }

  const imagesElement = document.getElementById('product-images');
  if (!imagesElement) {
    return -1;
  }

  const images = JSON.parse(imagesElement.textContent);


  // Try to find an exact match
  let index = images.findIndex(image => image === variantImage.src);
  
  // If no exact match, try to find a partial match
  if (index === -1) {
    index = images.findIndex(image => variantImage.src.includes(image) || image.includes(variantImage.src));
  }

  return index;
}

function updateProductImage(variant) {
  const imageIndex = findVariantImageIndex(variant);
  if (window.productSplide && imageIndex !== -1) {
    window.productSplide.go(imageIndex);
    lastValidImageIndex = imageIndex;
  } else {
    console.log('No matching image found or Splide instance not available. Keeping current slide.');
    if (window.productSplide) {
      window.productSplide.go(lastValidImageIndex);
    }
  }
}

console.log('Cart JavaScript loaded');